// start:ng42.barrel
import './multi-person-picker.directive';
import './person-picker-summary.directive';
import './person-picker.directive';
// end:ng42.barrel

